import { map } from 'lodash'

const allergenIncludedAllergensDetailsFormInitialValues =
  includedAllergens => ({
    allergenIncludedAllergenIds: map(includedAllergens, 'id'),
  })

export default allergenIncludedAllergensDetailsFormInitialValues
